import React, { useId } from 'react';
import { InfoTipp } from '../../components/Erklaerung';

// Gruppe A „Meine Einstellungen“ (Gestaltung 08.10.2026, GESTALTUNG.md 2.8): eine Einstellung als Zeile – Bezeichnung und
// graue Erklärung links, Wert oder Steuerung rechts, darunter optional ein Teil über die volle Breite (etwa ein
// aufgeklapptes Formular oder eine Meldung). Anders als Zeile aus Bausteine.tsx bleibt sie ihr eigener Abschnitt: section
// mit Überschrift, also Rolle region mit ihrem Namen. So behalten Passwort, Zwei-Faktor-Anmeldung, Daten herunterladen,
// Konto löschen und die übrigen bisherigen Abschnitte ihre Rolle und Überschrift für Bildschirmleser; sichtbar sind sie
// eine Zeile mit denselben Klassen wie der Baustein (einstellungen.css), Feinheiten in einst-meine.css.
// ebene: 2 steht die Zeile direkt im Bereich, 3 in einem Abschnitt mit eigener Überschrift.
// F-24 (PF-TX-rahmen-2): tipp setzt das Symbol mit Tooltip hinter den Titel, außerhalb des label (sonst schaltete ein Klick auf
// das Symbol den Schalter um); ohne tipp unverändert. Das Symbol steht auch außerhalb der Überschrift, damit ihr Name gleich bleibt.
export function EinstellungsZeile({ titel, erklaerung, zusatz, children, unter, ebene = 2, className, tipp, tippWort }: {
  titel: React.ReactNode; erklaerung?: React.ReactNode; zusatz?: React.ReactNode; children?: React.ReactNode;
  unter?: React.ReactNode; ebene?: 2 | 3; className?: string; tipp?: React.ReactNode; tippWort?: string;
}) {
  const id = useId();
  const Titel = ebene === 3 ? 'h3' : 'h2';
  const wort = tippWort ?? (typeof titel === 'string' ? titel : '');
  const ueberschrift = <Titel id={id} className="einst-zeile-titel">{titel}</Titel>;
  return <section className={className ? `einst-zeile einst-meine-zeile ${className}` : 'einst-zeile einst-meine-zeile'} aria-labelledby={id}>
    <div className="einst-zeile-text">
      {tipp && wort ? <div className="erkl-titelzeile">{ueberschrift}<InfoTipp wort={wort} text={tipp} /></div> : ueberschrift}
      {erklaerung && <p className="einst-zeile-erklaerung">{erklaerung}</p>}
      {zusatz}
    </div>
    {React.Children.toArray(children).length > 0 && <div className="einst-zeile-steuerung">{children}</div>}
    {unter && <div className="einst-zeile-unter">{unter}</div>}
  </section>;
}
